<!--
수출허가서 > 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="wrapper"
        :uk-sticky="stickyLayout"
    >
        <!-- 전체작업 -->
        <div v-show="! itemChecked" class="uk-flex uk-flex-between uk-flex-bottom">
            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg">
                {{ batch.item_checked_nothing_msg }}
            </div>

            <div class="uk-width-expand"></div>

            <!-- 전체 엑셀 -->
            <button
                class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                type="button"

                @click="searchedExec(excel)"
            >
                <i class="material-icons">list</i>
                검색결과 {{ excel.name }} 다운로드
            </button>

            <!-- 전체 소비세 부적용 리스트 -->
            <button
                class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                type="button"

                @click="searchedExec(taxedExportItemList)"
            >
                <i class="material-icons">list</i>
                검색결과 {{ taxedExportItemList.name }} 다운로드
            </button>


            <!-- 전체 커머셜인보이스 -->
            <button
                class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                type="button"

                @click="searchedExec(commercialInvoice)"
            >
                <i class="material-icons">list</i>
                검색결과 {{ commercialInvoice.name }} 다운로드
            </button>

            <!-- 전체 bl -->
            <button
                class="uk-button uk-button-white uk-button-small"
                type="button"

                @click="searchedExec(bl)"
            >
                <i class="material-icons">list</i>
                검색결과 {{ bl.name }} 다운로드
            </button>
        </div>

        <!-- 선택작업 -->
        <div v-show="itemChecked" class="uk-card uk-card-default uk-card-small">
            <div class="uk-card-body uk-flex uk-flex-between uk-flex-bottom">
                <!-- 선택개수안내 -->
                <div class="selected-msg" v-html="itemCheckedInfo"></div>

                <div class="uk-width-expand"></div>

                <!-- 선택 엑셀다운 -->
                <button
                    class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    @click="selectedExec(excel)"
                >
                    <i class="material-icons">check</i>
                    선택항목 {{ excel.name }} 다운로드
                </button>

                <!-- 선택 소비세 부적용 리스트 -->
                <button
                    class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    @click="selectedExec(taxedExportItemList)"
                >
                    <i class="material-icons">check</i>
                    선택항목 {{ taxedExportItemList.name }} 다운로드
                </button>

                <!-- 선택 커머셜인보이스 -->
                <button
                    class="uk-button uk-button-white uk-button-small uk-margin-small-right"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    @click="selectedExec(commercialInvoice)"
                >
                    <i class="material-icons">check</i>
                    선택항목 {{ commercialInvoice.name }} 다운로드
                </button>

                <!-- 선택 bl -->
                <button
                    class="uk-button uk-button-white uk-button-small"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    @click="selectedExec(bl)"
                >
                    <i class="material-icons">check</i>
                    선택항목 {{ bl.name }} 다운로드
                </button>
            </div>
        </div>


        <!-- 처리중화면 blockui -->
        <overlay-loading ref="down-overlay">
            <div slot="dialog">
                <loading-icon></loading-icon>
                다운로드중.. 잠시만 기다리세요.
            </div>
        </overlay-loading>

    </div>

</template>

<script>
    import checkedCountable from '../../checked-countable';
    import stickiable from '../../stickable';
    import searchedSelectable from '../../searched-selectable';
    import LoadingIcon from "../../../common/loading-icon.vue";
    import OverlayLoading from "../../../common/overlay-loading.vue";

    export default {
        mixins: [
            checkedCountable,
            stickiable,
            searchedSelectable,
        ],
        components: {
            LoadingIcon,
            OverlayLoading,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * 총괄관리자 여부
             */
            hasGeneral: {
                type: Boolean,
                default: false
            },
        },
        data: function () {

            return {
                // bl 정보
                bl: {
                    accept: 'pdf',
                    format: 'bl',
                    name: 'BL(송장)',
                },
                // 커머셜인보이스 정보
                commercialInvoice: {
                    accept: 'pdf',
                    format: 'commercial-invoice',
                    name: 'Commercial Invoice(소비세환급)',
                },
                // 소비세부적용 리스트 정보
                taxedExportItemList: {
                    accept: 'pdf',
                    format: 'taxed-export-item-list',
                    name: '소비세부적용리스트(PDF)',
                },
                // 엑셀 정보
                excel: {
                    accept: 'excel',
                    format: 'excel',
                    name: '소비세부적용리스트(엑셀)',
                },
            };
        },
        computed: {
            // 선택작업 버튼 비활성화 여부
            checkedDisabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

            // 스티키 레이아웃 적용여부
            stickyLayout() {
                return this.onSticky && this.itemChecked;
            },

        },
        methods: {
            /**
             * 선택 다운실행
             */
            selectedExec(info) {
                let confirm_msg = '선택한 내역을 ' + info.name + ' 다운로드 하시겠습니까?' + '\n(총 ' + this.itemCheckedCount + '건)';

                let url = new URL(this.basedUrl);
                let searchParams = url.searchParams;
                searchParams.set("__accept", info.accept);
                searchParams.set("format", info.format);

                // post 파라메터 작성
                let post_params = new URLSearchParams();
                post_params.set("_token", this.csrfToken);
                let checked_ids = _.map(this.checkedItems, 'id');
                _.each(checked_ids, (id) => {
                    post_params.append("id_in[]", id);
                  //  searchParams.append("id_in[]", id);
                });
                //post_params = null;
                //console.log(url.toString()); return;
                //console.log(checked_ids); return;

                // fetch 옵션
                let fetch_options = {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    body: post_params,
                };

                // 다운처리
                this.download(url, fetch_options, [
                    confirm_msg,
                    this.guardNoSelected,
                ]);
            },

            /**
             * 검색결과 BL(송장)다운
             */
            searchedExec(info) {
                let confirm_msg = '검색된 모든 내역을 ' + info.name + ' 다운로드 하시겠습니까?' + '\n(총 ' + this.searchedCount + '건)';

                let url = new URL(this.searchedUrl);
                let searchParams = url.searchParams;
                searchParams.set("__accept", info.accept);
                searchParams.set("format", info.format);
                //console.log(url.toString());

                // fetch 옵션
                let fetch_options = {

                };

                // 다운처리
                this.download(url, fetch_options, [
                    confirm_msg,
                    this.guardSearchedDownLimit,
                ]);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: #fff;
        //border-bottom: 1px solid #ddd;
        //padding-bottom: 0.5rem;


    }

    .no-selected-msg {
        color: #999;
    }

</style>